import { createIcon } from '@/assets/icons/helper.tsx';

export const Stopwatch = createIcon(
  <>
    <g clipPath="url(#stopwatch-clip)">
      <mask
        id="stopwatch-mask"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path d="M32 0H0V32H32V0Z" fill="white" />
      </mask>
      <g mask="url(#stopwatch-mask)">
        <path d="M21.2 4H16.4V6H21.2V4Z" fill="#489E9A" />
        <path
          d="M14 1.60039C14 0.937647 14.5373 0.400391 15.2 0.400391H22.4C23.0627 0.400391 23.6 0.937647 23.6 1.60039V2.80039C23.6 3.46313 23.0627 4.00039 22.4 4.00039H15.2C14.5373 4.00039 14 3.46313 14 2.80039V1.60039Z"
          fill="#BCE5D5"
        />
        <path
          d="M0.799976 10.5H9.19998C9.58654 10.5 9.89998 10.8134 9.89998 11.2C9.89998 11.5866 9.58654 11.9 9.19998 11.9H0.799976C0.413376 11.9 0.0999756 11.5866 0.0999756 11.2C0.0999756 10.8134 0.413376 10.5 0.799976 10.5Z"
          fill="#489E9A"
        />
        <path
          d="M1.99993 18.5H9.19993C9.58649 18.5 9.89993 18.8134 9.89993 19.2C9.89993 19.5866 9.58649 19.9 9.19993 19.9H1.99993C1.61333 19.9 1.29993 19.5866 1.29993 19.2C1.29993 18.8134 1.61333 18.5 1.99993 18.5Z"
          fill="#489E9A"
        />
        <path
          d="M3.60002 22.5H9.20002C9.58658 22.5 9.90002 22.8134 9.90002 23.2C9.90002 23.5866 9.58658 23.9 9.20002 23.9H3.60002C3.21342 23.9 2.90002 23.5866 2.90002 23.2C2.90002 22.8134 3.21342 22.5 3.60002 22.5Z"
          fill="#489E9A"
        />
        <path
          d="M3.60002 14.5H9.20002C9.58658 14.5 9.90002 14.8134 9.90002 15.2C9.90002 15.5866 9.58658 15.9 9.20002 15.9H3.60002C3.21342 15.9 2.90002 15.5866 2.90002 15.2C2.90002 14.8134 3.21342 14.5 3.60002 14.5Z"
          fill="#489E9A"
        />
        <path
          d="M18.8 31.6002C26.0901 31.6002 32 25.6904 32 18.4002C32 11.11 26.0901 5.2002 18.8 5.2002C11.5098 5.2002 5.59998 11.11 5.59998 18.4002C5.59998 25.6904 11.5098 31.6002 18.8 31.6002Z"
          fill="url(#stopwatch-gradient)"
        />
        <path
          d="M18.8 28.0008C24.1019 28.0008 28.4 23.7027 28.4 18.4008C28.4 13.0988 24.1019 8.80078 18.8 8.80078C13.498 8.80078 9.19995 13.0988 9.19995 18.4008C9.19995 23.7027 13.498 28.0008 18.8 28.0008Z"
          fill="#489E9A"
        />
        <path
          d="M18.8 20.0008C19.6836 20.0008 20.4 19.2844 20.4 18.4008C20.4 17.5171 19.6836 16.8008 18.8 16.8008C17.9163 16.8008 17.2 17.5171 17.2 18.4008C17.2 19.2844 17.9163 20.0008 18.8 20.0008Z"
          fill="#FFFCF2"
        />
        <path
          d="M18.2341 17.835L22.2343 13.8349C22.5467 13.5225 23.0533 13.5225 23.3657 13.8349C23.6781 14.1474 23.6781 14.6538 23.3657 14.9663L19.3656 18.9664L19.3048 19.0211C18.9905 19.2774 18.527 19.2593 18.2341 18.9664C17.9413 18.6735 17.9233 18.21 18.1795 17.8958L18.2341 17.835Z"
          fill="#FFFCF2"
        />
        <path
          d="M19.2 19.2006H12C11.5581 19.2006 11.2 18.8424 11.2 18.4006C11.2 17.9587 11.5581 17.6006 12 17.6006H19.2C19.6418 17.6006 20 17.9587 20 18.4006C20 18.8424 19.6418 19.2006 19.2 19.2006Z"
          fill="#FFFCF2"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="stopwatch-gradient"
        x1="32"
        y1="18.4002"
        x2="5.59998"
        y2="18.4002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCE5D5" />
        <stop offset="1" stopColor="#79C2BF" />
      </linearGradient>
      <clipPath id="stopwatch-clip">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </>,
  '0 0 32 32',
  'Stopwatch'
);
